import { paths } from './paths'

type TrackTraceLinkParams = { barcode: string }

// The postal code was removed from the T&T URLs. The onboarding app resolves it
// from the session-storage postal-code store (keyed by barcode) instead.
const trackTraceLink = ({ barcode }: TrackTraceLinkParams): string => `/${barcode}`

export const trackTraceLinks = {
  trackTraceOverviewLink: (params: TrackTraceLinkParams) => trackTraceLink(params),

  trackTraceDetailsLink: (params: TrackTraceLinkParams) => `${trackTraceLink(params)}/${paths.DETAILS}`,

  trackTraceSignatureLink: (params: TrackTraceLinkParams) => `${trackTraceLink(params)}/${paths.SIGNATURE}`,

  interventionsFormLink: ({ barcode, type }: TrackTraceLinkParams & { type?: string }) =>
    `/${barcode}/${paths.INTERVENTIONS}${type ? `/${type}` : ''}`,

  interventionsConfirmationLink: ({ barcode }: TrackTraceLinkParams) =>
    `/${barcode}/${paths.INTERVENTIONS}/${paths.CONFIRMATION}`,

  trackTraceLinks: () => ``,
}
